import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@kontentino/ui';

type Props = {
  type: 'empty' | 'error';
};

const MediaListAlertMessage: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-flex-1 tw-items-center tw-justify-center">
      <Alert variant={props.type === 'empty' ? 'info' : 'danger'}>
        {props.type === 'empty'
          ? t('mediaLibrary.emptyAlbum')
          : t('somethingWentWrongTryAgain')}
      </Alert>
    </div>
  );
};

export default MediaListAlertMessage;
